<template>
    <div class="special" :class="widClass">
        <div class="s-header">
            <span class="title" :class="widClass">昨日</span>
            <span class="s-cat" style="flex:1;"><a href="https://www.anyknew.com/rankings">查看日/周/月归档</a></span>
            <button class="op-btn" @click="toggleFeeds()" :class="{collapsed: showFeeds === true, mobile: widClass === 'mobile'}">
                <div class="op-btn-inner" v-if="showFeeds === true"><span class="op-hint">收起分类</span><img class="op-arrow" src="../assets/images/up-arrow.png"></div>
                <div class="op-btn-inner" v-else><span class="op-hint">展开分类</span><img class="op-arrow" src="../assets/images/down-arrow.png"></div>
            </button>
        </div>
        <div class="s-content-container" :class="widClass" v-if="showFeeds === true">
            <div class="rank-column" v-for="nos in this.nofColumns" :style="{width: columnWidth + 'px'}" :key="nos">
                <div class="rsingles">
                    <a :href="item.rlink" class="i-a" target="_blank" v-for="(item, index) in ritems.slice((nos - 1) * 7, (nos - 1) * 7 + 7)" v-bind:key="index">
                        <div class="rsingle">
                            <span v-if="widClass != 'mobile'"  class="seq" v-bind:class="{highlight: (index + (nos - 1) * 7) < 5 }">{{index + (nos - 1) * 7 + 1}}</span>
                            <span class="title" v-if="item.title !== null">
                                {{item.title}}
                            </span>
                            <span class="title last" v-else>
                                查看完整归档
                            </span>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
    export default {
        name: 'akrankings',
        data() {
            return{
                leftPos: 0,
                nofColumns: 4,
                columnWidth: 260,
                starts: [0, 10, 20, 30],
                widClass: 'small',
                ritems: [],
                showFeeds: false,
                istart: 0
            }
        },
        created: function () {
            this.setWidPara()
            window.addEventListener('resize', this.setWidPara);
            var that = this
            this.$http.get('/rankings/yesterday', {}, function (r) {
                if (r.status === 0) {
                    // 计算处理分类数据
                    if(that.widClass === 'mobile'){
                        that.ritems = r.data.res.mitems;
                    }
                    else{
                        that.ritems = r.data.res.items;
                    }
                    for (var i = 0; i < that.ritems.length; i++) {
                        if(i === that.nofColumns  * 7 - 1){
                            that.ritems[i]['rlink'] = '/rankings'
                            that.ritems[i]['title'] = null
                            break
                        }
                        else{
                            that.ritems[i]['rlink'] = '/go/' + that.ritems[i]['iid']
                        }
                    }
                    // 修改最后一条记录
                    if(localStorage.getItem('ystr') !== r.data.res.ystr){
                        localStorage.setItem('ystr', r.data.res.ystr)
                        that.showFeeds = true
                    }
                }
            })
        },
        methods: {
            toggleFeeds: function (){
                this.showFeeds = !this.showFeeds
            },
            setWidPara: function (){
                // var _width = screen.width
                var _width = document.body.clientWidth
                //ipad resolution
                //Portrait: 768x946
                //Landscape: 1024x690
                if(_width <= 375){
                    this.widClass = 'mobile'
                    this.nofColumns = 2
                    this.columnWidth = 175
                }
                else if(_width <= 500){
                    this.widClass = 'mobile'
                    this.nofColumns = 2
                    this.columnWidth = 190
                }
                else if(_width <= 770){
                    this.widClass = 'xxsmall'
                    this.nofColumns = 3
                    this.columnWidth = 220
                }
                else if(_width <= 1150){
                    this.widClass = 'xsmall'
                    this.nofColumns = 4
                    this.columnWidth = 225
                }
                else if(_width <= 1500){
                    this.widClass = 'small'
                    this.nofColumns = 4
                    this.columnWidth = 260
                }
                else if(_width <= 2050){
                    this.widClass = 'middle'
                    this.nofColumns = 5
                    this.columnWidth = 260
                }
                else if(_width > 2050){
                    this.nofColumns = 5
                    this.columnWidth = 260
                    this.widClass = 'large'
                }
            },
        }
    }
</script>

<style lang="less">
    .special{
        margin: auto;
        /*text-align: center;*/
        .s-header{
            display: flex;
            align-items: center;
            justify-content: left;
            width: 100%;
            padding: 20px 0 20px 0;
            .title{
                font-size: 1.2rem;
                margin-right: 20px;
                &.mobile{
                    margin-right: 10px;
                    padding-left: 10px;
                }
            }
            .s-cat{
                padding: 3px 8px;
                font-size: 0.8rem;
                letter-spacing: 1px;
                color: #3DB4F1;
                border-radius: 10px;
                /*margin: 0 10px;*/
                font-weight: 600;
                & a{
                    color: #3DB4F1;
                }
            }
            .op-btn{
                position: relative;
                padding: 3px 20px;
                border-radius: 3px;
                background-color: #3DB4F1;
                border: 1px solid #3DB4F1;
                color: #FFFFFF;
                &.mobile{
                    margin-right: 10px;
                }
                &.collapsed{
                    background-color: #f8f8f8;
                    border: 1px solid #3DB4F1;
                    color: #3DB4F1;
                }
                .op-btn-inner{
                    display: flex;
                    align-items: center;
                    .op-hint {
                        font-size: 0.7rem;
                    }
                    .op-arrow{
                        margin-left: 5px;
                        width: 12px;
                        height: 12px;
                    }
                }
            }
        }
        .s-content-container{
            width: 100%;
            position: relative;
            display: flex;
            justify-content: space-between;
            /*background-color: #BADEF1;*/
            &.mobile{
                padding: 0 10px 0 10px;
            }
            .rank-column{
                width: 260px;
                /*height: 450px;*/
                background-color: #FFFFFF;
                border-radius: 5px;
                padding:10px;
                @-o-keyframes fadeIt {
                    0%   { background-color: #FFFFFF; }
                    50%  { background-color: #BADEF1; }
                    100% { background-color: #FFFFFF; }
                }
                @keyframes fadeIt {
                    0%   { background-color: #FFFFFF; }
                    50%  { background-color: #BADEF1; }
                    100% { background-color: #FFFFFF; }
                }
                &.blink{
                    background-image:none !important;
                    -o-animation: fadeIt 1s ease-in-out;
                    animation: fadeIt 1s ease-in-out;
                }
                .rsingles{
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    height: 230px;
                    max-height: 100%;

                    a:visited {
                        .single{
                            .title{
                                color: #999999;
                                &.last{
                                    color: #3DB4F1;
                                }
                            }
                        }
                    }
                    .rsingle{
                        display: flex;
                        align-items: center;
                        justify-content: left;
                        font-size: 0.85rem;
                        /*padding-bottom: 12px;*/
                        &:hover{
                            /*background-color: #BADEF1;*/
                            /*padding: 15px 5px;*/
                            .seq{
                                color: #3DB4F1;
                            }
                            .title{
                                color: #3DB4F1;
                            }
                            .more{
                                color: #3DB4F1;
                            }
                        }
                        .seq{
                            color: #E2E2E2;
                            font-style: italic;
                            width: 25px;
                            &.highlight{
                                color: #3DB4F1;
                            }
                        }
                        .title{
                            flex: 1;
                            color: #333333;
                            .new-tag{
                                background-color: #3DB4F1;
                                font-size: 10px;
                                color: #FFFFFF;
                                padding: 0px 2px;
                                margin-left: 5px;
                            }
                            &.last{
                                color: #3DB4F1;
                            }
                        }
                        .more{
                            color: #999999;
                            font-size: 0.8rem;
                        }
                        &.null{
                            &:hover{
                                background-color: #FFFFFF;
                                padding: 0;
                            }
                            height: 25px;
                        }
                    }
                }
            }
        }

        &.xxsmall{
            width: 740px;
        }
        &.xsmall{
            width: 990px;
        }
        &.small{
            width: 1120px;
        }
        &.middle{
            width: 1520px;
        }
        &.large{
            width: 1900px;
        }
    }
</style>
